import * as Containers from '../Containers';

import { MediaArt } from './MediaArt';
import { MediaControls } from './MediaControls';
import { MediaMeta } from './MediaMeta';

export function Media(props) {
  return (
    <Containers.Control>
      <Containers.Select />
      <Containers.Action>
        <MediaArt deviceId={props.deviceId} />
        <MediaMeta deviceId={props.deviceId} component={props.component} />
        <MediaControls deviceId={props.deviceId} component={props.component} />
      </Containers.Action>
    </Containers.Control>
  );
}
